import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../Axiosinstance";
import Head from "./Headstu";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Card,
  TablePagination,
  TextField,
  MenuItem,
} from "@mui/material";
import { CloudUpload, Visibility } from "@mui/icons-material";
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import { decryptData } from "../Axiosinstance";

const BatchTable = () => {
  const { id: encryptedId, intakeId: encryptedIntakeId } = useParams();
  const id = decryptData(encryptedId);
  const intakeId = decryptData(encryptedIntakeId);

  console.log(id, intakeId, "new ");
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [rows, setRows] = useState([]);
  const [batchData, setBatchData] = useState(null);
  const [answersData, setAnswersData] = useState(null);
  const [submittedAnswers, setSubmittedAnswers] = useState({});

  const studentTeacherId = parseInt(decryptData(localStorage.getItem("studentteacherid")), 10);
  console.log(typeof studentTeacherId);
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;


  useEffect(() => {
    fetchAssessmentData();
    fetchBatchData();
    fetchAnswers();
  }, [id]);

  useEffect(() => {
    if (answersData) {
      // Store submitted answers with additional details
      const submittedData = {};
      answersData.forEach((answer) => {
        submittedData[answer.trentAssessmentId] = {
          url: answer.url,
          approver: answer.approver || "N/A",
          comments: answer.comments || "N/A",
          grade: answer.grade || "N/A",
        };
      });
      setSubmittedAnswers(submittedData);
      console.log("submittedData",submittedData)
    }
  }, [answersData]);

  const fetchAssessmentData = async () => {
    try {
      const response = await axios.get(`trent_assessments/${id}`);
      setRows(response.data);
    } catch (error) {
      console.error("Error fetching assessments:", error);
    }
  };

  const fetchBatchData = async () => {
    try {
      const response = await axios.get(`batch/${id}`);
      setBatchData(response.data);
    } catch (error) {
      console.error("Error fetching batch data:", error);
    }
  };

  const fetchAnswers = async () => {
    try {
      const response = await axios.get(`submissions/student/${studentTeacherId}`);
      setAnswersData(response.data);
    } catch (error) {
      console.error("Error fetching answers:", error);
    }
  };

  const handleFileUpload = async (event, assessmentId, moduleName) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", CLOUDINARY_UPLOAD);
    formData.append("public_id", `LMS/Trent/${file.name}`);

    try {
      const response = await fetch(baseURL, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.secure_url) {
        const fileUrl = data.secure_url;

        const confirmUpload = window.confirm("Are you sure you want to submit this file?");
        if (confirmUpload) {
          const submissionData = {
            studentId: studentTeacherId,
            trentAssessmentId: assessmentId,
            url: fileUrl,
            batchId: id,
            intakeId: intakeId,
            moduleName: moduleName
          };

          await axios.post("submissions/upload", submissionData);

          setUploadedFiles((prev) => ({
            ...prev,
            [assessmentId]: fileUrl,
          }));

          alert("File uploaded and submitted successfully!");
          fetchAnswers();
        }
      }
    } catch (error) {
      console.error("File upload failed:", error);
      alert("File upload failed. Please try again.");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = rows.filter(
    (row) =>
      row.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedModule === "" || row.moduleName === selectedModule)
  );

  return (
    <div style={{ textAlign: "center", marginTop: "2%" }}>
      <Head />
      <Card sx={{ maxWidth: "1300px", margin: "auto" }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{
            color: "primary.main",
            textDecoration: "underline",
            textUnderlineOffset: "6px",
            letterSpacing: "1px",
            textAlign: "center",
            mt: 3,
            mb: 4,
            fontSize: "2rem",
          }}
        >
          {batchData?.name || "Batch Assessments"}
        </Typography>

        <Box display="flex" justifyContent="space-between" sx={{ mb: 2, px: 2, gap: 2 }}>
          <TextField
            label="Search Module"
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ flex: 1 }}
          />
          <TextField
            select
            label="Filter by Module"
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            sx={{ flex: 1 }}
          >
            <MenuItem value="">All Modules</MenuItem>
            {batchData?.moduleDetails.map((row) => (
              <MenuItem key={row.id} value={row.moduleName}>
                {row.moduleName}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                {/* <TableCell sx={{ fontWeight: "bold" }}>Batch ID</TableCell> */}
                <TableCell sx={{ fontWeight: "bold" }}>Module Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Mark</TableCell>
                {/* <TableCell sx={{ fontWeight: "bold" }}>Comments</TableCell> */}
                <TableCell sx={{ fontWeight: "bold" }}>Approver</TableCell>
                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="body1" color="textSecondary">
                      No data available
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const answerDetails = submittedAnswers[row.id] || {}; // Get saved data

                  return (
                    <TableRow key={row.id}>
                      {/* <TableCell>{row.batchId}</TableCell> */}
                      <TableCell>{row.moduleName}</TableCell>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>{answerDetails.grade || "N/A"}/100</TableCell>
                      {/* <TableCell>{answerDetails.comments || "N/A"}</TableCell> */}
                      <TableCell>{answerDetails.approver || "N/A"}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => window.open(row.url, "_blank")}
                        >
                          View Question
                        </Button>

                        {!answerDetails.url ? (
                          <>
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx"
                              style={{ display: "none" }}
                              id={`file-upload-${row.id}`}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file && file.size > 8 * 1024 * 1024) {
                                  e.target.value = ""; // Reset file input
                                  alert("File size must be less than 8MB.");
                                } else {
                                  handleFileUpload(e, row.id, row.moduleName);
                                }
                              }}
                            />
                            <label htmlFor={`file-upload-${row.id}`}>
                              <Button
                                variant="contained"
                                color="secondary"
                                component="span"
                                startIcon={<CloudUpload />}
                                sx={{ ml: 2 }}
                              >
                                Upload Assessment
                              </Button>
                            </label>
                          </>
                        ) : (
                          <Button
                            variant="contained"
                            color="success"
                            startIcon={<Visibility />}
                            onClick={() => window.open(answerDetails.url, "_blank")}
                            sx={{ ml: 2 }}
                          >
                            View Submission
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
};

export default BatchTable;